var DiscountReason = /** @class */ (function () {
    function DiscountReason(props) {
        Object.assign(this, props);
        this.discount = {
            value: props.import,
            type: props.type
        };
    }
    return DiscountReason;
}());
export default DiscountReason;
export var TypeDiscount = {
    Fix: 'fix',
    Percentage: 'percentage'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountReasons/Model.tsx
// module id = 205
// module chunks = 0